<mat-label *ngIf="isOptional" class="relative mt-6"
  >{{ 'Hashtags' | transloco
  }}<span class="text-secondary ms-1">({{ 'Optional' | transloco }})</span>
</mat-label>
<mat-label *ngIf="!isOptional" class="relative mt-6 text-secondary"
  >{{ 'Hashtags' | transloco }}
</mat-label>

<div class="flex flex-col p-0">
  <mat-form-field appearance="fill" class="py-2">
    <input
      matInput
      #observationHashtagTrigger="matAutocompleteTrigger"
      [placeholder]="'ObservationHashtagsPlaceholder' | transloco"
      [formControl]="hashtagsControl"
      [matAutocomplete]="auto"
      [disabled]="loadingHashtags"
      (keydown.enter)="onEnterKeydown($event)"
      (focus)="onHashtagInputActivate()"
      (click)="onHashtagInputActivate()"
      maxlength="20"
      id="observation-hashtag-input"
    />
    <mat-icon
      matSuffix
      class="add-icon cursor-pointer"
      [matTooltip]="'Add hashtag' | transloco"
      (mousedown)="$event.preventDefault()"
      (click)="onAddIconClick($event)"
      *ngIf="
        hashtagsControl.value &&
        !hasHashtag('' + hashtagsControl.value) &&
        !loadingHashtags &&
        isOptional
      "
      id="observation-hashtag-add"
      >add_circle
    </mat-icon>

    <mat-spinner *ngIf="loadingHashtags" [diameter]="25" matSuffix></mat-spinner>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
      <mat-option
        *ngFor="let hashtag of filteredHashtags | async; index as j"
        [value]="hashtag"
        id="observation-hashtag-list-item{{ j }}"
      >
        {{ hashtag }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div class="selected-hashtags">
    <mat-chip-list>
      <mat-chip
        *ngFor="let hashtag of selectedHashtagsArray; index as i"
        [selectable]="true"
        [removable]="true"
        (removed)="removeHashtag(hashtag)"
        id="observation-hashtag-chip{{ i }}"
      >
        {{ hashtag }}
        <mat-icon
          matChipRemove
          svgIcon="mat_outline:cancel"
          id="observation-hashtag-chip{{ i }}-remove"
        ></mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
